export default "__VITE_ASSET__Ccph27CK__"